<template>
  <div>
    <TableFilters
      :filters="['supplier']"
      :columns="columns"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <!-- {{suppliers}} -->
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="suppliers"
              item-key="id"
              class="row-pointer product-list"
              id="indextable16"
            >
              <template v-slot:item.wareHouse="{ item }">
                {{ item.wareHouse.name }}</template
              >
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Date',
        value: 'date',
        align: 'left',
        show: true,
        disabled: false,
        render: (item) => moment(item.date).format('YYYY-MM-DD'),
      },
      {
        text: ' Reference no',
        value: 'reference_number',
        show: true,
        align: 'left',
        disabled: true,
        render: (item) => item?.reference_number,
      },

      {
        text: 'Warehouse',
        value: 'wareHouse',
        show: true,
        align: 'left',
        disabled: false,
        render: (item) => item?.wareHouse.name,
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        width: '12.5%',
        render: (item) => item?.status,
      },
    ],
    suppliers: [],
    hide: '',
    // Filters
    filter: {
      name: '',
      supplier: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.supplier) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        var filter = this.filter;

        axios
          .get(`reports/supplier/${filter.supplier}/purchase-order`)

          .then((res) => {
            let i = 1;
            this.suppliers = res.data.rows;
            this.suppliers.map((p) => {
              p.no = i;
              i++;
            });
            setTimeout(() => {
              callBack();
              // Update Pdf To List

              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.suppliers);
              // Update Pdf To List_Title
              this.$store.commit(
                'UPDATE_PDF_TITLE',
                'Supplier Purchase Orders',
              );
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            }, 100);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

            this.messages = err.data.title;
          });
      } else {
        this.$confirm('Please Select the Supplier then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.suppliers.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.suppliers);
        for (let x = 0; x < Data.length; x++) {
          Data[x].date = moment(Data[x].date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );

          Data[x].wareHouse = Data[x].wareHouse.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica');
        doc.text('Suppliers Purchases Order Report', 15, 5);

        doc.setFontSize(9);
        doc.text(
          246,
          5,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        // this.filterDatas.supplierquery
        // ? doc.text(
        //    `Supplier       -     ${this.filterDatas.supplierquery}`,
        //   15,
        //    11
        //  )
        // : null;

        const conditions = [{ key: 'supplierquery', label: 'Supplier' }];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
          },
        );
        const today = new DateTime();
        doc.save(
          `${moment(today).format('DD-MM-YYYY')}-supplierPurchaseOrder.pdf`,
        );
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable16');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-supplierPurchaseOrder.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
    ...mapState(['filterDatas']),
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
